import { RoutineFilterKey, RoutineFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useRoutineFilter = () => {
  return useFilter(
    RoutineFilterKey,
    'routineFilter',
    (filter: any) => new RoutineFilterModel(filter),
    true
  );
};
